import { useEffect, useRef } from "react";

// For a sheet or full-screen flow over the page: focus moves to `startRef` when it opens, Tab stays inside
// `containerRef`, Escape calls onClose, and focus goes back to what opened it when it closes. When that
// element has gone (one flow replaced another), focus goes to the first match of `fallbackSelector`.
export function useModalFocus({ containerRef, startRef, onClose, fallbackSelector }) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const opener = document.activeElement;
    (startRef?.current || containerRef.current)?.focus();
    const onKey = (e) => {
      if (e.key === "Escape") { closeRef.current(); return; }
      if (e.key !== "Tab" || !containerRef.current) return;
      const items = [...containerRef.current.querySelectorAll("button:not([disabled]), input, select, textarea")];
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      const inside = containerRef.current.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first || document.activeElement === startRef?.current)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (!inside || document.activeElement === last)) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      const back = opener?.isConnected ? opener : fallbackSelector && document.querySelector(fallbackSelector);
      back?.focus?.();
    };
  }, [containerRef, startRef, fallbackSelector]);
}
